export enum EDIT_MODES {
    QUOTE_INFORMATION = 1,
    DRAW_COUNTERS = 2,
    EDGE_COLOR = 3,
    BUMPS_RADIUSES = 4,
    BACKSPLASH = 5,
    SINK_COOKTOP = 6,
    OPTIONAL_ITEMS = 7,
    PRICING_PRINTING = 8
};

export class ApplicationState {
    static CURRENTMODE: EDIT_MODES = EDIT_MODES.DRAW_COUNTERS;
    public static contextMenuX: number = 0;
    public static contextMenuY: number = 0;
}
